import React from 'react';
import { Badge } from '@/components/ui/badge';
import { getJobStatusLabel } from '@/utils/jobStatus';

const STATUS_VARIANT = {
  completed: 'default',
  approved: 'default',
  cancelled: 'destructive',
  rejected: 'destructive',
  revision_requested: 'secondary',
  waiting_delivery: 'outline',
  delivery_processing: 'outline',
};

const JobStatusBadge = ({ status }) => (
  <Badge
    variant={STATUS_VARIANT[status] || 'outline'}
    className="border-white/20 bg-white/10 text-white/90"
  >
    {getJobStatusLabel(status)}
  </Badge>
);

export default JobStatusBadge;
